import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Zeiterfassung() {
  const { user } = useAuth();
  const [eintraege, setEintraege] = useState([]);
  const [filter, setFilter] = useState({ woche: '', user_id: '' });
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get('/zeiterfassung').then(r => setEintraege(r.data)).catch(() => {});
    if (user?.role === 'admin') api.get('/users').then(r => setUsers(r.data)).catch(() => {});
  }, []);

  const filtered = eintraege.filter(z => {
    if (filter.user_id && z.user_id !== parseInt(filter.user_id)) return false;
    if (filter.woche && !z.datum.startsWith(filter.woche)) return false;
    return true;
  });

  const toNum = v => parseFloat(v) || 0;
  const totalStunden = filtered.reduce((s, z) => s + toNum(z.stunden), 0);

  const userSummary = {};
  filtered.forEach(z => {
    if (!userSummary[z.user_name]) userSummary[z.user_name] = 0;
    userSummary[z.user_name] += toNum(z.stunden);
  });

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Zeiterfassung</div>
          <div className="page-sub">{filtered.length} Einträge</div>
        </div>
        <div style={{ fontFamily: 'monospace', background: 'var(--blue)', color: 'white', padding: '8px 16px', borderRadius: 'var(--radius)', fontSize: 14, fontWeight: 600, display: 'flex', alignItems: 'center' }}>
          Gesamt: {totalStunden.toFixed(1)} Std.
        </div>
      </div>

      {/* Filter */}
      <div className="card" style={{ marginBottom: 12 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
          <div className="form-group" style={{ flex: '0 0 auto' }}>
            <label className="form-label">Monat (YYYY-MM)</label>
            <input className="form-input" type="month" value={filter.woche} onChange={e => setFilter(f => ({ ...f, woche: e.target.value }))} />
          </div>
          {user?.role === 'admin' && (
            <div className="form-group" style={{ flex: '0 0 auto' }}>
              <label className="form-label">Mitarbeiter</label>
              <select className="form-select" value={filter.user_id} onChange={e => setFilter(f => ({ ...f, user_id: e.target.value }))}>
                <option value="">Alle</option>
                {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
              </select>
            </div>
          )}
          <button className="btn btn-secondary btn-sm" style={{ marginTop: 16 }} onClick={() => setFilter({ woche: '', user_id: '' })}>Zurücksetzen</button>
        </div>
      </div>

      {/* Summary cards (admin only) */}
      {user?.role === 'admin' && Object.keys(userSummary).length > 0 && (
        <div style={{ display: 'flex', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
          {Object.entries(userSummary).map(([name, std]) => (
            <div key={name} style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '10px 16px', minWidth: 140 }}>
              <div style={{ fontSize: 11, color: 'var(--text-2)', fontWeight: 600 }}>{name}</div>
              <div style={{ fontSize: 22, fontWeight: 700, fontFamily: 'monospace', color: 'var(--blue)', marginTop: 2 }}>{std.toFixed(1)}h</div>
            </div>
          ))}
        </div>
      )}

      <div className="card">
        {filtered.length === 0 ? (
          <div className="empty">
            <div className="empty-icon">⏱</div>
            <h3>Keine Einträge</h3>
            <p>Noch keine Zeiterfassungseinträge vorhanden.</p>
          </div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Datum</th>
                  {user?.role === 'admin' && <th>Mitarbeiter</th>}
                  <th>Baustelle</th>
                  <th>Einstempel</th>
                  <th>Ausstempel</th>
                  <th>Stunden</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(z => (
                  <tr key={z.id}>
                    <td style={{ fontFamily: 'monospace', fontSize: 12 }}>
                      {z.datum ? new Date(z.datum).toLocaleDateString('de-DE') : '–'}
                    </td>
                    {user?.role === 'admin' && <td style={{ fontWeight: 500 }}>{z.user_name}</td>}
                    <td>{z.baustelle_name || '–'}</td>
                    <td style={{ fontFamily: 'monospace' }}>{z.einstempel}</td>
                    <td style={{ fontFamily: 'monospace' }}>{z.ausstempel || '–'}</td>
                    <td style={{ fontWeight: 600, fontFamily: 'monospace' }}>
                      {z.stunden ? `${toNum(z.stunden).toFixed(1)}h` : '–'}
                    </td>
                    <td>
                      {z.ausstempel
                        ? <span className="badge badge-blue">Fertig</span>
                        : <span className="badge badge-green">Aktiv</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
